import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { BottomSheet } from 'components/bottom-sheet';
import Dialog from 'components/dialog';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';
import { routes } from 'utils/routing';

import { Body, Container, Header, Text } from './styled';
import { DismissPromptProps } from './types';

export const DismissPrompt = ({ isOpen, onClose }: DismissPromptProps) => {
  const isDesktopWeb = useIsDesktopWebBreakpoint();

  const router = useRouter();

  const eventMessage = 'Store locator close prompt';

  const content = (
    <Container>
      <Body paddingX={isDesktopWeb ? '$0' : '$2'}>
        <Header>{t('storeLocatorClosePromptHeading')}</Header>
        <Text>{t('storeLocatorClosePromptBody')}</Text>
      </Body>
      <ScrollView showsVerticalScrollIndicator={isDesktopWeb}>
        <ActionButton onPress={onClose}>{t('selectStore')}</ActionButton>
        <ActionButton
          marginTop="$4"
          variant={ActionButtonVariants.OUTLINE_V2}
          onPress={() => router.replace(routes.base)}
          _hover={{ _text: { color: primitive.$white } }}
        >
          {t('goToHomepage')}
        </ActionButton>
      </ScrollView>
    </Container>
  );

  return isDesktopWeb ? (
    <Dialog
      showDialog={isOpen}
      modalAppearanceEventMessage={eventMessage}
      contentMaxWidth="520px"
      onDismiss={onClose}
      bodyComponent={content}
      closeOnOverlayClick
      contentPadding="$4"
    />
  ) : (
    <BottomSheet onOpenEventMessage={eventMessage} isOpen={isOpen} onClose={onClose}>
      <View style={styles.contentWrapper}>{content}</View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  contentWrapper: {
    alignItems: 'stretch',
  },
});
